<template>
    <b-dropdown class="my-2 mr-1">
        <template #button-content>
            <div class="noti-icon">
                <i class="fas fa-bell"></i>
                <b-badge class="bg-gradient-warning">{{alertas.length}}</b-badge>
            </div>
        </template>

        <b-dropdown-item-button @click="abrirAlerta(alertas[i-1].id)" v-for="i in (alertas.length < 5 ? alertas.length : 5)" :key="`alerta_${i}`">
            <div class="d-flex">
                <b-avatar class="mr-2" :style="`background: ${getEnum(alertas[i-1].tipo).color}`">
                    <i :class="getEnum(alertas[i-1].tipo).icon"></i>
                </b-avatar>
                <div class="corpo-alerta">
                    <div class="h6 text-titulo">{{alertas[i-1].titulo}}</div>
                    {{alertas[i-1].corpo}}
                </div>
            </div>
        </b-dropdown-item-button>
        <b-dropdown-item to="/alertas" class="text-center">
            <i class="fas fa-eye mr-2"></i>
            <span>Ver todos</span>
        </b-dropdown-item>

    </b-dropdown>
</template>
<script>
import helpers from '@/common/utils/helpers';


export default {
    methods : {
        getEnum(enumName) {
            if(!helpers.getEnum(enumName))
                return {
                    color : '#333',
                    icon : 'fas fa-question'
                }
            return helpers.getEnum(enumName);
        },
        tratarCss : function(mensagem){
            return mensagem.replace("width: 150px;", "");
        },
        
        abrirAlerta : function(id){
            this.$router.push({ name : 'alertas-detalhes', params : { id : id } });
        }
    },
    mounted(){
        this.$store.dispatch("app/buscarAlertas");
        setInterval(() => {
            this.$store.dispatch("app/buscarAlertas");
        }, 30000);
    },
    computed : {
        alertas : function(){
            return this.$store.state.app.alertas;
        },
        usuario : function(){
            return this.$store.state.app.userInfo;
        }
    },
    watch : {
        usuario : function(){
            this.$store.dispatch("app/buscarAlertas");
        }
    }
}
</script>
<style>
    .corpo-alerta{
        max-width: 500px;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
        display: inline-block;
    }
</style>